import { ArrowDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface ScrollButtonProps {
  onClick: () => void
  visible: boolean
  className?: string
}

export function ScrollButton({ onClick, visible, className }: ScrollButtonProps) {
  if (!visible) return null

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={onClick}
      className={cn(
        'absolute bottom-4 right-4 z-10 rounded-full shadow-lg',
        'bg-background/95 backdrop-blur-sm border-border/50',
        'hover:bg-muted transition-all duration-200',
        'animate-in fade-in-0 slide-in-from-bottom-2',
        className,
      )}
    >
      <ArrowDown className="h-4 w-4" />
    </Button>
  )
}
